import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Wallet } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const FIELDS = [
  ["upi_id", "UPI ID (e.g. yourname@upi)"],
  ["account_name", "Bank account name"],
  ["account_number", "Bank account number"],
  ["ifsc", "IFSC"],
  ["bank_name", "Bank name"],
];

export default function SellerPayments() {
  const [cfg, setCfg] = useState({ upi_id: "", account_name: "", account_number: "", ifsc: "", bank_name: "", note: "" });
  const [saved, setSaved] = useState(false);

  const load = useCallback(() => {
    api.get("/seller/payment-config").then(({ data }) => setCfg(data)).catch((e) => toast.error(formatError(e)));
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      await api.put("/seller/payment-config", cfg);
      toast.success("Payment details saved — customers can now pay you directly via your store page");
      setSaved(true);
    } catch (e) {
      toast.error(formatError(e));
    }
  };

  const configured = cfg.upi_id || cfg.account_number;

  return (
    <div data-testid="seller-payments" className="max-w-xl">
      <div className="border border-slate-100 rounded-xl p-6">
        <p className="font-heading font-bold flex items-center gap-2"><Wallet className="w-4 h-4 text-blue-500" /> Receive payments</p>
        <p className="text-xs text-slate-400 mt-1 mb-5">
          Enter your own UPI or bank details. They are shown on your public store page so customers can pay you directly.
          Hello Nanba never fills these in for you.
        </p>
        <div className="space-y-3">
          {FIELDS.map(([k, label]) => (
            <label key={k} className="block text-xs font-semibold text-slate-500">{label}
              <input data-testid={`vendor-paycfg-${k.replace(/_/g, "-")}`} value={cfg[k] || ""} onChange={(e) => setCfg({ ...cfg, [k]: e.target.value })}
                className="mt-1 w-full h-10 rounded-md border border-slate-200 px-3 text-sm outline-none focus:border-blue-500" />
            </label>
          ))}
          <label className="block text-xs font-semibold text-slate-500">Note to customers (optional)
            <input data-testid="vendor-paycfg-note" value={cfg.note || ""} onChange={(e) => setCfg({ ...cfg, note: e.target.value })}
              placeholder='e.g. "Share payment screenshot on WhatsApp"'
              className="mt-1 w-full h-10 rounded-md border border-slate-200 px-3 text-sm outline-none focus:border-blue-500" />
          </label>
        </div>
        <div className="flex items-center gap-3 mt-4">
          <Button data-testid="vendor-paycfg-save" onClick={save} className="rounded-md bg-slate-900">Save payment details</Button>
          {configured && saved && <span className="text-xs font-semibold text-emerald-600">Active on your store page</span>}
        </div>
      </div>
    </div>
  );
}
